import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react'
import GlobalPopUp from '../../../../utility/globalPopUp';
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from "../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss"
import globalStyles from "../../../../../assets/styles/global.module.scss";
import workflowStyles from "../../../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { useFlowBuilderStore } from '../../../../../store/flowBuilderStore';
import { getVariableToVariableValueText } from '../../flowBuilderConstants';
import VariableAssignmentPopup from './variableAssignment/variableAssignmentPopup';


const VariableAssignmentFormComponents = (props: any) => {

    const { actionData, stepAction } = props;
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)'); 
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const { onChangeCurrentActiveNodeConfig, nodes, setNodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const [flagSaveVariableToVariablePopup, setFlagSaveVariableToVariablePopup] = useState<boolean>(false);

    const storeBackupValue = () => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            { type: "store_backup_value" },
            {
                updateType: "editExistingStepAction"
            }
        )
    }

    const handleCancelClick = () => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            { type: "cancel_changes" },
            {
                updateType: "editExistingStepAction"
            }
        ); 
        setFlagSaveVariableToVariablePopup(false);
    }

    return (
        <>
            <Grid item>
                <Grid container direction={"column"} gap={"12px"}>
                    <Grid item mt={2} className={textStyles.templatesContainer}>
                        <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                            <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                Variable Assignment
                            </Grid>
                            <Grid item className={`${styles.contentBlockSubHeadingStyle} ${workflowStyles.resetVariableText}`}>
                                <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                    <Grid item className={globalStyles.wordBreakBreakWord}>
                                        {getVariableToVariableValueText(customVariableList, actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id, actionData?.source_chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id, actionData?.variable_static_value, "left section")}
                                    </Grid>
                                    <Grid item>
                                        <ModeEditIcon className={styles.editActionIcon} onClick={() => { setFlagSaveVariableToVariablePopup(true); storeBackupValue();}} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {flagSaveVariableToVariablePopup &&
                    <GlobalPopUp
                        open={flagSaveVariableToVariablePopup}
                        onClose={() =>  {setFlagSaveVariableToVariablePopup(false); handleCancelClick();}}
                        flagBackdrop
                        paperMinWidth={flagSmallScreen ? "280px" : "650px"}
                        paperMaxwidth={flagSmallScreen ? "580px" : "650px"}
                        flagShowCloseIcon={true}
                        // height={"100%"}
                        titlePadding='0'
                        handleClose={() => {setFlagSaveVariableToVariablePopup(false); handleCancelClick();}}
                    >
                        <VariableAssignmentPopup 
                            actionData={actionData} 
                            stepAction={stepAction} 
                            setFlagSaveVariableToVariablePopup={setFlagSaveVariableToVariablePopup}
                            handleCancelClick={handleCancelClick}     
                        />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default VariableAssignmentFormComponents
